import { Action, createReducer, on } from "@ngrx/store";
import * as tagsActions from './tags.actions';
import { IPagination } from "src/app/shared/models/page.model";
import { ITag } from "../models/tags.models";

export interface TagsState {
  allTags: ITag[],
  metadata: IPagination | null;
  tags: ITag[],
  loading: boolean,
  keyword: string
}

export const initialTagsState: TagsState = {
  allTags: [],
  metadata: null,
  tags: [],
  loading: false,
  keyword: ''
}

const featureReducer = createReducer(
  initialTagsState,
  on(
    tagsActions.FetchAllTagsSuccess,
    (state, action) => ({
      ...state,
      allTags: action.tags,
    })
  ),
  on(
    tagsActions.FetchTagsSuccess,
    (state, action) => ({
      ...state,
      tags: action.tags.data,
      metadata: action.tags.metadata
    })
  ),

  on(tagsActions.AddTagSuccess, (state, action) => ({
    ...state,
    allTags: [...state.allTags, action.tag as ITag],
  })),
  on(tagsActions.SetTagsLoader, (state, action) => ({
    ...state,
    loading: action.isLoading
  })),
  on(tagsActions.SetTagSearch, (state, action) => ({
    ...state,
    keyword: action.keyword
  }))
)

export function tagsReducer(state: TagsState | undefined, action: Action) {
  return featureReducer(state, action);
}
